//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderHeadCalcs', {
//        templateUrl: 'views/components/views/orderHeadCalcs/orderHeadCalcs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'orderHeadCalcsService', function ($stateParams, stateService, utilityService, orderHeadCalcsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderInternalNo = $stateParams.order_internal_no;
            
//            vm.model = {
//                setting: {},
//                itemsListCalculations: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await orderHeadCalcsService.getSetting({ order_internal_no: orderInternalNo }))[0];
//            }
            
//            async function loadCalculations() {
//                if (utilityService.validateParmsValue(vm.model.setting.order_internal_no) !== true) return;

//                vm.model.itemsListCalculations = await orderHeadCalcsService.listCalculations({ order_internal_no: vm.model.setting.order_internal_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'custactedit':
//                        go({
//                            custact_no: '0',
//                            filterfield: 'order_internal_no',
//                            filtervalue: vm.model.setting.order_internal_no
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCalculations();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
